import type { FaireProductEntity } from "../../entity_types/product";

export const p_xymdtg6pb2: FaireProductEntity = {
  token: "p_xymdtg6pb2",
  type: "product",
  name: "Ghost Large Squishy",
  brandToken: "b_gcd5wc4rkp",
  brandName: "Treat Yourself Boutiques",
  imageUrl:
    "https://cdn.faire.com/fastly/b7f27da0560d07c218214b70dd162d38a7a217949413b7f1967bf392de5c1d2d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4db3f4885b509273e60efdb05912e51b5d4a5f75dbf1dc7f6a0475a21c34eb59.jpeg",
  ],
  priceDollars: 9.99,
  description:
    "Enjoy the Ghost Large Squishy from Treat Yourself Boutiques. This viral large ghost squishy offers a satisfying, slow-rise squeeze. Its charming ghost design adds a whimsical touch, making it an engaging toy for kids. A fun and colorful addition to our range of playful indulgences.",
  tags: [],
  msrpDollars: 19.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:27.932Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
